import React, { useState } from "reactn";
import appHook from "../../../../../../hooks/appHook";
import PropTypes from "prop-types";

// components
import Input from "../../../../../_common/form/input/Input";
import Select from "../../../../../_common/form/select/Select";
import FormGroup from "../../../../../_common/form/form_group/FormGroup";
import InputGroup from "../../../../../_common/form/input_group/InputGroup";
import Label from "../../../../../_common/form/label/Label";
import AddElement from "../../../../../_common/form/addElement/AddElement";
import Error from "../../../../../_common/error/Error";

//config
import { CountiesConfig } from "../../../../../_config/Counties.config";

const AddressNational = props => {
  const { handleChange, handleKeyup, handleBlur, values, errors } = props;
  const { handleFocus, focus } = appHook();
  const [lineThree, setLineThree] = useState(false);
  const [lineFour, setLineFour] = useState(false);
  return (
    <>
      <FormGroup
        error={errors.newnationaladdresslineone}
        focused={
          focus === "newnationaladdresslineone" ? true : !!(false || values.newnationaladdresslineone)
        }
      >
        <InputGroup>
          <Label htmlFor="newnationaladdresslineone" text="Address Line 1" />
          <Input
            id="newnationaladdresslineone"
            type="text"
            name="newnationaladdresslineone"
            change={handleChange}
            keyup={handleKeyup}
            focus={handleFocus}
            blur={handleBlur}
            value={values.newnationaladdresslineone || ""}
            required
          />
        </InputGroup>
        {errors.newnationaladdresslineone && <Error error={errors.newnationaladdresslineone} />}
      </FormGroup>
      <FormGroup
        error={errors.newnationaladdresslinetwo}
        focused={
          focus === "newnationaladdresslinetwo" ? true : !!(false || values.newnationaladdresslinetwo)
        }
      >
        <InputGroup>
          <Label htmlFor="newnationaladdresslinetwo" text="Address Line 2" />
          <Input
            id="newnationaladdresslinetwo"
            type="text"
            name="newnationaladdresslinetwo"
            change={handleChange}
            keyup={handleKeyup}
            focus={handleFocus}
            blur={handleBlur}
            value={values.newnationaladdresslinetwo || ""}
            required
          />
        </InputGroup>
        {errors.newnationaladdresslinetwo && <Error error={errors.newnationaladdresslinetwo} />}
      </FormGroup>
      {!lineThree && !values.newnationaladdresslinethree && (
        <AddElement click={() => setLineThree(true)}>
          <p>
            <span>+</span>Add an address line
          </p>
        </AddElement>
      )}
      {(lineThree || values.newnationaladdresslinethree) && (
        <>
          <FormGroup
            error={errors.newnationaladdresslinethree}
            focused={
              focus === "addresslinethree"
                ? true
                : !!(false || values.newnationaladdresslinethree)
            }
          >
            <InputGroup>
              <Label htmlFor="newnationaladdresslinethree" text="Address Line 3" />
              <Input
                id="newnationaladdresslinethree"
                type="text"
                name="newnationaladdresslinethree"
                change={handleChange}
                keyup={handleKeyup}
                focus={handleFocus}
                blur={handleBlur}
                value={values.newnationaladdresslinethree || ""}
                required
              />
            </InputGroup>
            {errors.newnationaladdresslinethree && (
              <Error error={errors.newnationaladdresslinethree} />
            )}
          </FormGroup>
          {!lineFour && !values.newnationaladdresslinefour && (
            <AddElement click={() => setLineFour(true)}>
              <p>
                <span>+</span>Add an address line
              </p>
            </AddElement>
          )}
        </>
      )}
      {(lineFour || values.newnationaladdresslinefour) && (
        <FormGroup
          error={errors.newnationaladdresslinefour}
          focused={
            focus === "addresslinefour"
              ? true
              : !!(false || values.newnationaladdresslinefour)
          }
        >
          <InputGroup>
            <Label htmlFor="addresslinefour" text="Address Line 4" />
            <Input
              id="newnationaladdresslinefour"
              type="text"
              name="newnationaladdresslinefour"
              change={handleChange}
              keyup={handleKeyup}
              focus={handleFocus}
              blur={handleBlur}
              value={values.newnationaladdresslinefour || ""}
              required
            />
          </InputGroup>
          {errors.newnationaladdresslinefour && <Error error={errors.newnationaladdresslinefour} />}
        </FormGroup>
      )}
      <FormGroup
        error={errors.newnationalpostcode}
        focused={focus === "postcode" ? true : !!(false || values.newnationalpostcode)}
      >
        <InputGroup>
          <Label htmlFor="newnationalpostcode" text="Eircode" />
          <Input
            id="newnationalpostcode"
            type="text"
            name="newnationalpostcode"
            change={handleChange}
            keyup={handleKeyup}
            focus={handleFocus}
            blur={handleBlur}
            value={values.newnationalpostcode || ""}
            required
          />
        </InputGroup>
        {errors.newnationalpostcode && <Error error={errors.newnationalpostcode} />}
      </FormGroup>
      <FormGroup error={errors.nationalcounty} focused>
        <InputGroup>
          <Select
            id="nationalcounty"
            type="text"
            name="nationalcounty"
            change={handleChange}
            keyup={handleKeyup}
            focus={handleFocus}
            blur={handleBlur}
            labelText="County"
            options={CountiesConfig}
            value={values.nationalcounty || ""}
            defaultValue={"County"}
            required
          />
        </InputGroup>
        {errors.nationalcounty && <Error error={errors.nationalcounty} />}
      </FormGroup>
    </>
  );
};

AddressNational.propTypes = {
  handleChange: PropTypes.func,
  handleKeyup: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object
};

export default AddressNational;
